module.exports = __webpack_public_path__ + "static/media/times-circle-white.d73ddc57.svg";